<script>
    import language from '../language/da_DK.json';
    import Modal from "svelte-simple-modal";
    import InformationContent from "../Components/InformationContent.svelte";
    import {storedInput, storedResult} from '../global.ts';
    import {navigate} from "svelte-navigator";
    import '../../public/global.css';

    let showInputs = false;
    const result = $storedResult;
    const input = $storedInput;

    function handleBackButton() {
        navigate('/');
    }

    function handleShowInputs() {
        showInputs = !showInputs;
    }
</script>

<button class="back-button" on:click={handleBackButton}>
    <img src="/images/back_button.svg" alt="back-button"/>
</button>

<div class="container">
    <section class="header">
        <div class="titles">
            <h1>{language.title}</h1>
            <h2>{language.result}</h2>
        </div>
        <Modal styleContent={{ backgroundColor: '#F6F3F0', borderRadius: '0.3125rem', paddingBottom: '2rem' }}>
            <InformationContent/>
        </Modal>
    </section>

    <section class="result-input-section">
        <h3 class="calculation-header">{language.calculationHeader}</h3>
        <section class={showInputs ? "result-input-wrapper" : "inactive-input-wrapper"} on:click={handleShowInputs}>
            <section>
                {#if showInputs}
                    <table>
                        <tbody>
                        <tr>
                            <td>
                                <div class="data-wrapper">
                                    <img src="images/{input.type.id}_black.svg" alt="type icon"/>
                                    <span>
                                        {language.type}
                                    </span>
                                </div>
                            </td>
                            <td>{input.type.label}</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="data-wrapper">
                                    <img src="images/{input.placement.id}_black.svg" alt="placement icon"/>
                                    <span>
                                        {language.placement}
                                    </span>
                                </div>
                            </td>
                            <td>{input.placement.label}</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="data-wrapper">
                                    <img src="/images/diameter_black.svg" alt="diameter icon"/>
                                    <span>
                                        {language.diameter}
                                    </span>
                                </div>
                            </td>
                            <td>{input.diameter.diameter} {language.mm}</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="data-wrapper">
                                    <img src="/images/bearing_black.svg" alt="bearing icon"/>
                                    <span>{language.bearing}</span>
                                </div>
                            </td>
                            <td>{input.bearing.bearing}</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="data-wrapper">
                                    <img src="/images/insulation_class_black.svg" alt="insulation class icon"/>
                                    <span>{language.insulationClass}</span>
                                </div>
                            </td>
                            <td>{input.insulationClass.insulation_class}</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="data-wrapper">
                                    <img src="/images/temp_black.svg" alt="temperature icon"/>
                                    <span>{language.temperature}</span>
                                </div>
                            </td>
                            <td>{input.temp.temp} {language.celsius}</td>
                        </tr>
                        </tbody>
                    </table>
                {/if}
            </section>
            <section class="calculation-content">
                <span>{!showInputs ? language.showCalculation : ""}</span>
                <span class="show-input-button">
                    {showInputs ? language.hide : language.show}
                </span>
            </section>
        </section>
    </section>

    {#if result.length !== 0}
        <section class="result-product-section">
            <h3>{language.matchingProducts}</h3>
            {#each result as r}
                <section class="result-product-wrapper">
                    {#if r.imgSrc}
                        <img src={r.imgSrc} alt="logo icon" class="isover-image"/>
                    {/if}
                    <span class="product">
                        <a href={r.url} target="_blank" class="product-link" id="product-link">
                            {r.name}
                        </a>
                    </span>
                    <div class="result-product-thickness">
                    {#if r.colored}
                        {#if r.thickness.length > 2}
                            <span class="result-product-value"><span
                                    class="red-span">{r.thickness.substring(0, r.thickness.indexOf('/'))}</span>{r.thickness.substring(r.thickness.indexOf('/'))}</span>
                        {:else}
                            <span class="red-span result-product-value">{r.thickness}</span>
                        {/if}
                    {:else}
                        <span class="result-product-value">{r.thickness}</span>
                    {/if}
                    </div>
                </section>
            {/each}
        </section>
        
        <section class="product-info-section">
            {#if result.some(p => p.name.includes('ISOVER'))}
                <p>Isover: <span class="red-span">{language.red}</span> = {language.blankOutside} / {language.black}
                    = {language.matteOutside}</p>
            {/if}
<!--            {#if result.some(p => p.name.includes('Kaimann'))}
                <p>Kaimann: <span class="red-span">{language.red}</span> = {language.twoLayerInsulation}</p>
            {/if}-->
        </section>
    {:else }
        <section class="no-products-section">
            <span>{language.noResults}</span>
        </section>
    {/if}
</div>

<style>
</style>